export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';
export const NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED';